import { isEmpty } from "lodash";
import React, { Component } from "react";
import {
  Form as FormUi,
  Container,
  Button,
  Icon,
  Dropdown,
  Segment,
  Header,
  Table,
  Label,
} from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import AddCheckpointModal from "./addCheckpointModal";
import ModalEditRouteCheckpoint from "./routeModalEdit";
import { translate } from "react-i18next";

export class RouteCheckpoints extends Component {
  checkpointModal = () => {
    this.setState({ checkPointModal: true });
  };
  editcheckpointModal = (data) => {
    console.log('open');
    this.setState({ editcheckPointModal: true, editdata: data });
  };
  onEditCheckpointModalClose = () => {
    this.setState({ editcheckPointModal: false });
  };
  onCheckpointModalClose = () => {
    this.setState({ checkPointModal: false });
  };
  constructor(props) {
    super(props);

    this.state = {
      checkPointModal: false,
      editcheckPointModal: false,
      editdata: '',
      beforeCheckpoints: [],
    };
  }

  componentDidMount() {
    ReadAxios({
      url: `routeManagerCheckPoints/${this.props.route_id}`,
    })
      .then((res) => {
        this.setState({
          beforeCheckpoints: isEmpty(res.data.resultSet)
            ? []
            : res.data.resultSet,
        });
      })
      .catch((err) => {
        this.setState({
          beforeCheckpoints: [],
        });
      });
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <Table size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="5">
                <Header size="tiny" className="labelName" color="blue">
                {t("checkpoint_table_header.checkpoint_details") || "Checkpoint Details"}{" "}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="right">
                <Button
                  size="mini"
                  type="button"
                  onClick={this.checkpointModal}
                  icon
                  primary
                >
                  <Icon name="plus" /> {t("checkpoint_action_button.add_checkpoint") || "Add Checkpoint"}{" "}
                </Button>
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>
                <Header
                  size="tiny"
                  className="labelName p-bold-500"
                  color="black"
                >
                  {t("checkpoint_table_header.checkpoint_name") || "Checkpoint Name"}{" "}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Header
                  size="tiny"
                  className="labelName p-bold-500"
                  color="black"
                >
                  {t("checkpoint_table_header.Checkpoint_type") || "Checkpoint Type"}{" "}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Header
                  size="tiny"
                  className="labelName p-bold-500"
                  color="black"
                >
                  {t("checkpoint_table_header.eta") || "ETA"}{" "}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Header
                  size="tiny"
                  className="labelName p-bold-500"
                  color="black"
                >
                  {t("checkpoint_table_header.etd") || "ETD"}{" "}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Header
                  size="tiny"
                  className="labelName p-bold-500"
                  color="black"
                >
                  {t("checkpoint_table_header.return_eta") || "Return ETA"}{" "}
                </Header>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Header
                  size="tiny"
                  className="labelName p-bold-500"
                  color="black"
                >
                  {t("checkpoint_table_header.return_etd") || "Return ETD"}{" "}
                </Header>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.beforeCheckpoints.length > 0 ? (
              this.state.beforeCheckpoints.map((checkpoint, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{checkpoint.checkPointName} <Button
                      onClick={() => this.editcheckpointModal(checkpoint)}
                      basic
                      size="mini"
                      type="button"
                      icon
                    >
                      {" "}
                      <Icon name="edit" color="green" />
                    </Button>
                  </Table.Cell>
                  <Table.Cell>{checkpoint.checkPointType}</Table.Cell>
                  <Table.Cell>{checkpoint.eta}</Table.Cell>
                  <Table.Cell>{checkpoint.etd}</Table.Cell>
                  <Table.Cell>{checkpoint.r_eta}</Table.Cell>
                  <Table.Cell>{checkpoint.r_etd}</Table.Cell>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Cell colSpan="6">
                  <LoadingPlaceholder />
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        <AddCheckpointModal
          open={this.state.checkPointModal}
          onClose={this.onCheckpointModalClose}
          route_id={this.props.route_id}
          addAfter={this.state.beforeCheckpoints}
        />
        <ModalEditRouteCheckpoint 
          open={this.state.editcheckPointModal}
          onClose={this.onEditCheckpointModalClose}
          route_details={this.props.route_id}
          addAfter={this.state.editdata}
        />
      </>
    );
  }
}

export default translate("route")(RouteCheckpoints);
